<template>
  <div class="actions-wrapper">
    <p class="actions-title">功能</p>
    <div v-for="item in actionsData" :key="item.id" class="action-item flex-between" @click="cvAction(item)">
      <div class="action-item-left flex-start">
        <div class="action-img-wrapper">
          <img :src="item.icon" alt="">
        </div>
        <div class="action-item-text flex-column">
          <span class="title">{{ item.title }}</span>
          <span class="desc">{{ item.desc }}</span>
        </div>
      </div>
      <span class="iconfont iconchevron-right" />
    </div>
  </div>
</template>

<script>
import { envMixin } from '@/assets/js/mixin/global'

export default {
  mixins: [envMixin],
  data () {
    return {}
  },
  created () {
	  this.iosReview()
  },
  components: {},
  watch: {},
  computed: {
    actionsData () {
      if (this.isReviewOfIos && this.isIos) {
        return [
          { id: 1, icon: 'https://files.wondercv.com/mobile/cvs/email-icon.png', title: '求职邮箱', desc: '专业求职邮箱，提高简历通过率' },
          { id: 3, icon: 'https://files.wondercv.com/mobile/cvs/daniu-icon.png', title: '简历模板', desc: '拿到名企 offer 的真人优秀简历' }
        ]
      } else {
        return [
          // { id: 1, icon: 'https://files.wondercv.com/mobile/cvs/email-icon.png', title: '求职邮箱', desc: '专业求职邮箱，提高简历通过率' },
          {
            id: 2,
            icon: 'https://files.wondercv.com/mobile/cvs/mentor-icon.png',
            title: '导师辅导',
            desc: '1V1 简历优化，提升 2 倍面试机会'
          },
          { id: 3, icon: 'https://files.wondercv.com/mobile/cvs/daniu-icon.png', title: '简历模板', desc: '拿到名企 offer 的真人优秀简历' }
        ]
      }
    }
  },
  methods: {
    cvAction ({ id }) {
      switch (id) {
        // case 1:
        //   if (this.isIos && this.iosVersion && this.iosVersion < '2.4.5') {
        //     this.$emit('updateVersion')
        //   } else {
        //     window.location.href = `${process.env.VUE_APP_LINK}/emails/my`
        //   }
        //   break
        case 2:
          this.$fn.jump(`${window.location.origin}/service`)
          // this.routeTo('/service')
          break
        case 3:
          if (this.isIos && this.iosVersion && this.iosVersion < '2.4.5') {
            this.$emit('updateVersion')
          } else {
            this.$fn.jump(`${window.location.origin}/jianlimoban/tuijian/`)
            // this.routeTo('/jianlimoban/tuijian/')
          }
          break
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/global/variable';
.actions-wrapper {
  padding: 28px 16px 42px;
  border-top: 12px solid #f9f9f9;
  .actions-title {
    color: $color-title;
    font-size: $font-size-medium-x;
    font-weight: 500;
    line-height: 16px;
    &::before {
      content: '';
      display: inline-block;
      width: 2px;
      height: 12px;
      background-color: $color-theme;
      border-radius: 1px;
      margin-right: 8px;
    }
  }
  .action-item {
    margin-top: 32px;
    .action-item-left {
      .action-img-wrapper {
        width: 46px;
        height: 46px;
        border-radius: 4px;
        margin-right: 14px;
        img {
          width: 46px;
        }
      }
      .action-item-text {
        line-height: 20px;
        font-size: $font-size-medium;
        font-weight: 400;
        .title {
          color: $color-title;
          margin-bottom: 6px;
          font-size: $font-size-medium-x;
        }
        .desc {
          color: #9c9c9c;
          font-size: $font-size-small;
        }
      }
    }
    .iconfont {
      font-size: 16px;
      font-weight: bold;
      color: $color-title;
    }
  }
}
</style>
